import { english } from "../content/english";
import { french } from "../content/french";

export const content = {
  english,
  french,
};
